import { useCallback } from "react";
import { Item } from "types";
import { useItems } from "atoms/itemAtom";
import { useSetAtom } from "jotai/index";
import { useAtom } from "jotai";

import { Checkbox } from "components/Checkbox/Checkbox";
import { Paragraph } from "components/Paragraph/Paragraph";
import { Row } from "components/Row/Row";

import { setPropertiesProductAtom } from "../../../atoms/modalAtom/modalAtom";
import { settingsAtom } from "../../../atoms/settingsAtom";

import styles from "../styles.module.scss";

type ItemProps = {
  item: Item;
  isActive?: boolean;
};

export function ProductItem({ item }: ItemProps) {
  const setPropertiesProduct = useSetAtom(setPropertiesProductAtom);
  const [settings] = useAtom(settingsAtom);
  const { itemsState, setItemsState } = useItems();
  const itemid = item.itemid || "";
  const isActive = itemsState.checkedItems[0]?.itemid === itemid;
  const isChecked = itemsState.checkedItems.some(
    (temp) => temp.itemid === item.itemid
  );

  const handleCheckUncheck = useCallback(() => {
    if (isChecked) {
      /*setItemsState({
        ...itemsState,
        checkedItems: itemsState.checkedItems.filter(
          (temp) => temp.itemid !== item.itemid
        ),
      });*/
      setPropertiesProduct(true);
      return;
    }

    setItemsState({
      ...itemsState,
      // checkedItems: [...itemsState.checkedItems, item],
      checkedItems: [item],
    });
  }, [item, itemsState]);

  return (
    <Row
      className={`hoverBg cursor-pointer ${isActive ? styles.isActive : ""}`}
      onClick={handleCheckUncheck}
    >
      <div className="flex flex-1 gap-6 items-center">
        {/*        <Checkbox
          checked={isChecked}
          onChange={handleCheckUncheck}
          onClick={(e) => e.stopPropagation()}
        />*/}
        <Paragraph width={100}>{item.itemid}</Paragraph>
        <Paragraph width={250}>{item.name}</Paragraph>
      </div>
      <Paragraph>
        {item.prices?.length && settings?.pricelistid
          ? item.prices.find((i) => i.pricelistid === settings.pricelistid)
              ?.price
          : "-"}
      </Paragraph>
    </Row>
  );
}
